/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_IntroInputs */

const en_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI moves fast. Here's where I build, agents, automation, mobile, and the infrastructure behind them.`)
};

const ar_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذكاء الاصطناعي يتحرك بسرعة. هنا أبني: الوكلاء، والأتمتة، والجوال، والبنية التحتية خلفها.`)
};

const bn_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI দ্রুত বদলাচ্ছে। আমি AI এজেন্ট, অটোমেশন, মোবাইল অ্যাপ আর সেগুলোর পেছনের ইনফ্রাস্ট্রাকচার তৈরি করি।`)
};

const de_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI bewegt sich schnell. Hier baue ich: Agenten, Automatisierung, Mobile und die Infrastruktur dahinter.`)
};

const es_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA se mueve rápido. Aquí es donde construyo: agentes, automatización, móvil y la infraestructura detrás.`)
};

const fr_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA évolue rapidement. C'est ici que je construis les agents, l'automatisation, le mobile et l'infrastructure qui les sous-tend.`)
};

const pt_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA se move rapidamente. É aqui que eu construo: agentes, automação, mobile e a infraestrutura por trás.`)
};

const zh_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 发展太快。这就是我开工的地方：智能体、自动化、移动端，以及它们背后的基础设施。`)
};

const tr_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ hızlı gider. Ajanları, otomasyonu, mobili ve arkalarındaki altyapıyı kurduğum yer burası.`)
};

const ru_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ несётся быстро. Вот где я создаю агентов, автоматизацию, мобайл и инфраструктуру под ними.`)
};

const pl_svc_intro = /** @type {(inputs: Svc_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI pędzi szybko. Tutaj buduję: agentów, automatyzację, mobile i infrastrukturę pod nimi.`)
};

/**
* | output |
* | --- |
* | "AI moves fast. Here's where I build, agents, automation, mobile, and the infrastructure behind them." |
*
* @param {Svc_IntroInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_intro = /** @type {((inputs?: Svc_IntroInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_IntroInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_intro(inputs)
	if (locale === "bn") return bn_svc_intro(inputs)
	if (locale === "de") return de_svc_intro(inputs)
	if (locale === "es") return es_svc_intro(inputs)
	if (locale === "fr") return fr_svc_intro(inputs)
	if (locale === "pt") return pt_svc_intro(inputs)
	if (locale === "zh") return zh_svc_intro(inputs)
	if (locale === "tr") return tr_svc_intro(inputs)
	if (locale === "ru") return ru_svc_intro(inputs)
	if (locale === "pl") return pl_svc_intro(inputs)
	return en_svc_intro(inputs)
});